var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-form',{ref:"form",attrs:{"field-metas":_vm.metas,"only-key":false,"index":0,"describe":false},on:{"syncData":_vm.handleSyncData},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }